import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '@/hoc';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
export var PopupTooltip = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.placement, placement = _b === void 0 ? 'top' : _b, _c = _a.containerClassName, containerClassName = _c === void 0 ? '' : _c;
    var _d = useState(false), visible = _d[0], setVisible = _d[1];
    var _e = useState({}), tooltipStyles = _e[0], setTooltipStyles = _e[1];
    var tooltipRef = useRef(null);
    var targetRef = useRef(null);
    var theme = useTheme().theme;
    var containerRef = useRef(null);
    var toolTipRoot = useMemo(function () {
        var toolTipRoot = document.getElementById('tooltip-root-container') ||
            document.createElement('div');
        if (!toolTipRoot.parentElement) {
            toolTipRoot.id = 'tooltip-root-container';
            document.documentElement.appendChild(toolTipRoot);
        }
        containerRef.current = toolTipRoot;
        return toolTipRoot;
    }, []);
    useEffect(function () {
        var container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
        if (!container)
            return;
        var setThemeProperties = function (obj, prefix) {
            if (prefix === void 0) { prefix = ''; }
            Object.entries(obj).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (typeof value === 'object' && value !== null) {
                    setThemeProperties(value, "".concat(prefix).concat(key, "-"));
                }
                else {
                    container.style.setProperty("--".concat(prefix).concat(key), String(value));
                }
            });
        };
        setThemeProperties(theme);
    }, [theme, containerRef === null || containerRef === void 0 ? void 0 : containerRef.current]);
    useEffect(function () {
        if (visible && tooltipRef.current && targetRef.current) {
            var targetRect = targetRef.current.getBoundingClientRect();
            var tooltipRect = tooltipRef.current.getBoundingClientRect();
            var styles = {};
            switch (placement) {
                case 'top':
                    styles = {
                        left: targetRect.left + window.scrollX + targetRect.width / 2 - tooltipRect.width / 2,
                        top: targetRect.top + window.scrollY - tooltipRect.height - 8,
                    };
                    break;
                case 'bottom':
                    styles = {
                        left: targetRect.left + window.scrollX + targetRect.width / 2 - tooltipRect.width / 2,
                        top: targetRect.bottom + window.scrollY + 8,
                    };
                    break;
                case 'left':
                    styles = {
                        left: targetRect.left + window.scrollX - tooltipRect.width - 8,
                        top: targetRect.top + window.scrollY + targetRect.height / 2 - tooltipRect.height / 2,
                    };
                    break;
                case 'right':
                    styles = {
                        left: targetRect.right + window.scrollX + 8,
                        top: targetRect.top + window.scrollY + targetRect.height / 2 - tooltipRect.height / 2,
                    };
                    break;
                default:
                    break;
            }
            // Adjust position if tooltip is outside the viewport
            var viewportWidth = window.innerWidth;
            var viewportHeight = window.innerHeight;
            if (typeof styles.left === 'number' && styles.left < 0) {
                styles.left = 8;
            }
            else if (typeof styles.left === 'number' &&
                styles.left + tooltipRect.width > viewportWidth) {
                styles.left = viewportWidth - tooltipRect.width - 8;
            }
            if (typeof styles.top === 'number' && styles.top < 0) {
                styles.top = 8;
            }
            else if (typeof styles.top === 'number' &&
                styles.top + tooltipRect.height > viewportHeight) {
                styles.top = viewportHeight - tooltipRect.height - 8;
            }
            setTooltipStyles(styles);
        }
    }, [visible, placement]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { ref: targetRef, onMouseEnter: function () { return setVisible(true); }, onMouseLeave: function () { return setVisible(false); }, className: 'relative inline-block w-full border-2 border-gray-500 rounded-full', children: children }), title &&
                visible &&
                createPortal(_jsx("div", { ref: tooltipRef, className: "absolute z-100002 shadow-xl p-2 text-black bg-white text-sm rounded ".concat(containerClassName), style: tooltipStyles, onMouseEnter: function () { return setVisible(true); }, onMouseLeave: function () { return setVisible(false); }, children: title }), toolTipRoot)] }));
};
